module.exports = __webpack_public_path__ + "img/u44.1e8220dc.svg";